import type { SectionMeta } from '@/types';

export const SECTIONS: readonly SectionMeta[] = [
  { id: 'home', label: 'الرئيسية' },
  { id: 'tools', label: 'أدوات الذكاء' },
  { id: 'qa', label: 'أسئلة وتفاعل' },
  { id: 'resources', label: 'مصادر تعليمية' },
  { id: 'gallery', label: 'أمثلة وصور' },
  { id: 'contact', label: 'تواصل معنا' },
] as const;

/** Per-section document title, appended to the site name. */
export const SECTION_TITLES: Record<SectionMeta['id'], string> = {
  home: 'الرئيسية',
  tools: 'أدوات الذكاء الاصطناعي المجانية',
  qa: 'أسئلة وتفاعل',
  resources: 'مصادر تعليمية موثوقة',
  gallery: 'أمثلة وصور وفيديوهات',
  contact: 'تواصل معنا',
};

export const SITE_NAME = 'منصة اصنع أثرك الرقمي';
